import * as React from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { Candidate } from '../../Model/Candidate';
import { ShowIcon } from './ShowIcon';

export interface RequestProfileButtonProps {
    candidate: Candidate;
    showIcon?: ShowIcon;
}

export class RequestProfileButton extends React.PureComponent<RequestProfileButtonProps> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    constructor(props: RequestProfileButtonProps, context: AppContext) {
        super(props, context);
        this.handleClick = this.handleClick.bind(this);
    }

    public render() {
        const props = this.props;
        const title = this.context.i18n.translate('Kandidatenprofil anfordern');
        const showIcon = props.showIcon;
        const iconBefore = showIcon === ShowIcon.Left ? <i className="fas fa-user-chart"/> : null;
        const iconAfter = showIcon === ShowIcon.Right ? <i className="fas fa-user-chart"/> : null;

        return <button className="jc-apply-now-button primary candidate" title={title} onClick={this.handleClick}>
            {iconBefore}
            <span>{title}</span>
            {iconAfter}
        </button>;
    }

    private handleClick() {
        this.context.requestProfile(this.props.candidate);
    }
}

